import React from "react";

export default function CasinoSuperskokPlacements(props) {
    function setPlace(nagrada, index) {
        if (nagrada.mjesto - props.info.nagradeLista[index - 1].mjesto >= 2) {
            return `${props.info.nagradeLista[index - 1].mjesto + 1}.-${nagrada.mjesto}. mjesto`;
        } else if (nagrada.mjesto - props.info.nagradeLista[index - 1].mjesto == 1) {
            return `${nagrada.mjesto}. mjesto`;
        }
    }

    return (
        <div>
            {props.info && <div className="podium">
                <span className="first-place">
                    <span className="image"></span>
                    <span className="text multiple-prizes">
                        <span className="left">1. mjesto</span>
                        <span className="right">
                            {props.info.nagradeLista[0].vrstaNagrade == null && <span>
                                {casino.utils.numberWithCurrencyFromated(props.info.nagradeLista[0].iznos, props.info.valuta)}
                            </span>}
                            {props.info.nagradeLista[0].vrstaNagrade == 1 && <span>
                                {casino.utils.numberWithCurrencyFromated(props.info.nagradeLista[0].iznos, props.info.valuta)}
                            </span>}
                            {props.info.nagradeLista[0].nagradaOpis != null && <span>
                                {" i " + props.info.nagradeLista[0].nagradaOpis}
                            </span>}
                            {props.info.nagradeLista[0].vrstaNagrade == 3 && <span>
                                {props.info.nagradeLista[0].iznos + " Supera"}
                            </span>}
                        </span>
                    </span>
                </span>
                <span className="second-place">
                    <span className="image"></span>
                    <span className="text multiple-prizes">
                        <span className="left">2. mjesto</span>
                        <span className="right">
                            {props.info.nagradeLista[1].vrstaNagrade == 1 && <span>
                                {casino.utils.numberWithCurrencyFromated(props.info.nagradeLista[1].iznos, props.info.valuta)}
                            </span>}
                            {props.info.nagradeLista[1].nagradaOpis != null && <span>
                                {" i " + props.info.nagradeLista[1].nagradaOpis}
                            </span>}
                            {props.info.nagradeLista[1].vrstaNagrade == 3 && <span>
                                {props.info.nagradeLista[1].iznos + " Supera"}
                            </span>}
                        </span>
                    </span>
                </span>
                <span className="third-place">
                    <span className="image"></span>
                    <span className="text multiple-prizes">
                        <span className="left">3. mjesto</span>
                        <span className="right">
                            {props.info.nagradeLista[2].vrstaNagrade == 1 && <span>
                                {casino.utils.numberWithCurrencyFromated(props.info.nagradeLista[2].iznos, props.info.valuta)}
                            </span>}
                            {props.info.nagradeLista[2].nagradaOpis != null && <span>
                                {" i " + props.info.nagradeLista[2].nagradaOpis}
                            </span>}
                            {props.info.nagradeLista[2].vrstaNagrade == 3 && <span>
                                {props.info.nagradeLista[2].iznos + " Supera"}
                            </span>}
                        </span>
                    </span>
                </span>
            </div>}
            <div className="placements">
                {props.info && props.info.nagradeLista.map((nagrada, index) =>
                (index > 2 && <div key={index} className="placement">
                    <span>{setPlace(nagrada, index)}</span>
                    <span>
                        {nagrada.vrstaNagrade == 1 ? nagrada.nagradaOpis ? casino.utils.numberWithCurrencyFromated(nagrada.iznos, props.info.valuta) + nagrada.nagradaOpis : casino.utils.numberWithCurrencyFromated(nagrada.iznos, props.info.valuta) : nagrada.vrstaNagrade == 2 ? nagrada.nagradaOpis : nagrada.iznos + " Supera"}
                    </span>
                </div>)
                )}
            </div>
        </div>
    )
}